import { render, staticRenderFns } from "./GestioneAttivitaProdottoViewComponent.vue?vue&type=template&id=6a2fc69c"
import script from "./GestioneAttivitaProdottoViewComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaProdottoViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports